import { DecimalScale } from '@globaleris/ui.library'
import { Chip, Grid, makeStyles, Paper, Typography } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { InvoiceSummaryDetailModel } from '../../../../../api/Argentia/endpoints/invoices/model/invoices'
import { formatLocaleNumber } from '../../../../../helpers/numberHelper'

interface InvoiceSummarySectionProps {
  summary?: InvoiceSummaryDetailModel
  isDirty: boolean
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2, 3),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  item: {
    textAlign: 'right',
    padding: theme.spacing(0, 3)
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: '0.7rem',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    whiteSpace: 'nowrap'
  },
  amount: {
    fontWeight: 500
  },
  totalAmount: {
    fontWeight: 700,
    fontSize: '1.15rem',
    color: theme.palette.primary.main
  },
  divider: {
    width: 1,
    alignSelf: 'stretch',
    background: theme.palette.divider
  },
  pendingChip: {
    background: '#fff3e0',
    color: '#e65100',
    marginRight: theme.spacing(3)
  }
}))

export const InvoiceSummarySection: React.FC<InvoiceSummarySectionProps> = ({
  summary,
  isDirty
}) => {
  const [t] = useTranslation(['invoiceEditPage'])
  const classes = useStyles()

  const fmt = (val?: number) =>
    val !== undefined ? `${formatLocaleNumber(val, DecimalScale.DEFAULT)} €` : '—'

  return (
    <Paper className={classes.root} elevation={2}>
      <Grid container alignItems="center" justify="flex-end" wrap="nowrap">
        {isDirty && (
          <Grid item style={{ marginRight: 16 }}>
            <Chip
              label={t('invoiceEditPage:summary.pendingChanges')}
              size="small"
              className={classes.pendingChip}
            />
          </Grid>
        )}

        <Grid item className={classes.item}>
          <Typography className={classes.label}>
            {t('invoiceEditPage:summary.totalGross')}
          </Typography>
          <Typography variant="body2" className={classes.amount}>
            {fmt(summary?.totalGross)}
          </Typography>
        </Grid>

        <div className={classes.divider} />

        <Grid item className={classes.item}>
          <Typography className={classes.label}>
            {t('invoiceEditPage:summary.totalDiscounts')}
          </Typography>
          <Typography variant="body2" className={classes.amount}>
            {fmt(summary?.totalDiscounts)}
          </Typography>
        </Grid>

        <div className={classes.divider} />

        <Grid item className={classes.item}>
          <Typography className={classes.label}>
            {t('invoiceEditPage:summary.totalTaxes')}
          </Typography>
          <Typography variant="body2" className={classes.amount}>
            {fmt(summary?.totalTaxes)}
          </Typography>
        </Grid>

        <div className={classes.divider} />

        <Grid item className={classes.item}>
          <Typography className={classes.label}>
            {t('invoiceEditPage:summary.totalInvoice')}
          </Typography>
          <Typography className={classes.totalAmount}>{fmt(summary?.totalInvoice)}</Typography>
        </Grid>
      </Grid>
    </Paper>
  )
}
